export const ContactTypes = {
  Work: { text: 'Work', value: 1 },
  Main: { text: 'Main', value: 2 },
  Office: { text: 'Office', value: 3 },
  Mobile: { text: 'Mobile', value: 4 },
};
